import { isFollowingAssistantBottom } from "./assistantStore";

type ScrollElement = { scrollHeight: number; scrollTop: number; clientHeight: number };

/** Keep reading position through streamed text growth. An explicit own send or
 * the latest control resumes following; an incoming reply does not. */
export class AssistantScrollFollow {
  following = true;
  private latestPendingId: string | undefined;

  observeScroll(element: ScrollElement): boolean {
    this.following = isFollowingAssistantBottom(element);
    return this.following;
  }

  update(element: ScrollElement, pendingId?: string): boolean {
    const ownSend = pendingId !== undefined && pendingId !== this.latestPendingId;
    this.latestPendingId = pendingId;
    if (this.following || ownSend) this.jumpToLatest(element);
    return this.following;
  }

  jumpToLatest(element: ScrollElement): boolean {
    this.following = true;
    element.scrollTop = Math.max(0, element.scrollHeight - element.clientHeight);
    return true;
  }
}
